import bplusClinicTH from "./bplusClinic/th.json";
import ishealthTH from "./IsHealth/th.json";
import cudentTH from "./cudent/th.json";
import raksthaiTH from "./raksthai/th.json"

import bplusClinicEN from "./bplusClinic/en.json";
import ishealthEN from "./IsHealth/en.json";
import cudentEN from "./cudent/en.json";
import raksthaiEN from "./raksthai/en.json"
import { megenCostEN, megenCostTH } from "./megenCost";
import { meerpEN, meerpTH } from "./meerp";

export const localizationTH = {
  ...meerpTH,
  ...megenCostTH,
  ...raksthaiTH,
  ...cudentTH,
  ...bplusClinicTH,
  ...ishealthTH,
}

export const localizationEN = {
  ...meerpEN,
  ...megenCostEN,
  ...raksthaiEN,
  ...cudentEN,
  ...bplusClinicEN,
  ...ishealthEN,
}
